import {request} from "./client";

/** A builder's own sales staff for live tours of their projects (they sign in to the OGM Agent app). */

export const getSiteStaff = () => request("/broker/site-staff");

export const addSiteStaff = (payload) => request("/broker/site-staff", {method: "POST", body: payload});

export const assignStaffProject = (agentId, projectId) =>
    request(`/broker/site-staff/${agentId}/sites`, {method: "POST", body: {projectId}});

export const unassignStaffProject = (agentId, assignmentId) =>
    request(`/broker/site-staff/${agentId}/sites/${assignmentId}`, {method: "DELETE"});

export const suspendSiteStaff = (agentId) => request(`/broker/site-staff/${agentId}`, {method: "DELETE"});

export const setUpStaffAuthenticator = (agentId) => request(`/broker/site-staff/${agentId}/authenticator`, {method: "POST"});

export const removeStaffAuthenticator = (agentId) =>
    request(`/broker/site-staff/${agentId}/authenticator`, {method: "DELETE"});
